import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs";
import { ResourceUtil } from "src/app/utils/resource.util";
import { DeviceDetectorService } from "ngx-device-detector";
import { IBrowserDetails } from "src/app/models/browser-details.model";
import { HeaderImageType } from "../../constants/header-image-type.constants";

import { AppUtil } from "./../../utils/app.util";
import { ValidatorFn } from "@angular/forms";
import { Parems } from "src/app/models/global-vars.model";
import { AccountCancellationInstructions } from "src/app/models/user/accountCancellationInstructions";
@Injectable({ providedIn: "root" })
export class GlobalService {
	public routerLastUrl: string = "";
	public routerCurrentUrl: string = "";
	public userActionCallFrom: string = "";
	public countyLandingByLogIn: boolean = false;
	public passwordChangeByLogIn: boolean = false;
	public loginExternalLink: boolean = false;
	public isAnnouncementFlow: boolean = true;
	public isCallFromloginExternalLink: boolean = false;
	public isAnnouncementVisible: boolean = false;
	public isAnnouncementPageVisible = new BehaviorSubject<boolean>(false);

	public cartNature: string = "TBD";
	public supportKioskPickup: boolean = undefined;

	public todate: Date = new Date(
		new Date().setFullYear(new Date().getFullYear() - 5)
	);
	//private headerImageType
	//public isHeaderDisplayed$: Observable<boolean> = new Observable<false>();
	private headerDisplayed = new BehaviorSubject<boolean>(false);
	private isCallFromQRCode = new BehaviorSubject<boolean>(false);
	private isCallFromDirectURL = new BehaviorSubject<boolean>(false);
	private isCallFromDirectURLAfterLogin = new BehaviorSubject<boolean>(false);
	public cancellationToken = new BehaviorSubject<boolean>(false);

	public staticResourceURL = ResourceUtil.getStaticResourceUrl();
	public externalResourcesUrl = ResourceUtil.getExternalResourcesUrl();
	public browserDetails: IBrowserDetails;
	public params: Parems;
	private headerImageType = new BehaviorSubject<string>(
		HeaderImageType.DEFAULT
	);

	constructor(private deviceService: DeviceDetectorService) {
		this.populateBrowserDetails();
	}

	public isQRCall$(): Observable<boolean> {
		return this.isCallFromQRCode.asObservable();
	}

	public setQrCall(toggleValue: boolean) {
		this.isCallFromQRCode.next(toggleValue);
	}
	public getQrCall() {
		return this.isCallFromQRCode.value;
	}

	public isDirectURLCall$(): Observable<boolean> {
		return this.isCallFromDirectURL.asObservable();
	}

	public setDirectURLCall(toggleValue: boolean) {
		this.isCallFromDirectURL.next(toggleValue);
	}
	public getDirectURLCall() {
		return this.isCallFromDirectURL.value;
	}

	public isAnnouncementPageVisible$(): Observable<boolean> {
		return this.isAnnouncementPageVisible.asObservable();
	}

	public setAnnouncementPageVisible(toggleValue: boolean) {
		this.isAnnouncementPageVisible.next(toggleValue);
	}
	public getAnnouncementPageVisible() {
		return this.isAnnouncementPageVisible.value;
	}

	public cancellationToken$(): Observable<boolean> {
		return this.cancellationToken.asObservable();
	}

	public setcancellationToken(toggleValue: boolean) {
		this.cancellationToken.next(toggleValue);
	}

	public getcancellationToken() {
		return this.cancellationToken.value;
	}

	public isDirectURLCallAfterLogin$(): Observable<boolean> {
		return this.isCallFromDirectURLAfterLogin.asObservable();
	}

	public setDirectURLCallAfterLogin(toggleValue: boolean) {
		this.isCallFromDirectURLAfterLogin.next(toggleValue);
	}
	public getDirectURLCallAfterLogin() {
		return this.isCallFromDirectURLAfterLogin.value;
	}

	public isHeaderDisplay$(): Observable<boolean> {
		return this.headerDisplayed.asObservable();
	}

	public toggleHeaderDisplay(toggleValue: boolean) {
		this.headerDisplayed.next(toggleValue);
	}

	public getHeaderDisplayedValue() {
		return this.headerDisplayed.value;
	}

	public setParams(data) {
		if (data) {
			this.params = data;
		}
	}

	public setDownIcon(event) {
		if (
			event.target &&
			event.target.offsetParent &&
			event.target.offsetParent.classList
		) {
			event.target.offsetParent.classList.remove("upArrow");
		}
	}
	public selectChangeByKey(event) {
		if (event.code === "Enter" || event.code === "Space") {
			this.selectChange(event);
		}
	}
	public selectChange(event) {
		if (
			event.target &&
			event.target.offsetParent &&
			event.target.offsetParent.classList
		) {
			if (!event.target.offsetParent.classList.contains("upArrow")) {
				event.target.offsetParent.classList.add("upArrow");
			} else {
				event.target.offsetParent.classList.remove("upArrow");
			}
		}
	}

	public trimValue(input) {
		if (input && input.value) {
			input.setValue(input.value.trim());
		}
	}

	public passwordValidation(): ValidatorFn {
		return control => {
			const errorList = {
				invalidLength: false,
				invalidLetters: false,
				invalidNumbers: false,
				invalidSymbols: false
			};
			if (!control.value) {
				return {
					invalidLength: true,
					invalidLetters: true,
					invalidNumbers: true,
					invalidSymbols: true
				};
			}

			let hasError = false;
			if (control.value.length < 8) {
				errorList.invalidLength = true;
				hasError = true;
			}
			if (!(control.value.match(/[a-z]/) && control.value.match(/[A-Z]/))) {
				errorList.invalidLetters = true;
				hasError = true;
			}
			if (!control.value.match(/[0-9]/)) {
				errorList.invalidNumbers = true;
				hasError = true;
			}
			if (!control.value.match(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/)) {
				errorList.invalidSymbols = true;
				hasError = true;
			}
			if (hasError) {
				return errorList;
			} else {
				return null;
			}
		};
	}
	public dateRangeValidator(type): ValidatorFn {
		return control => {
			if (!control.value) {
				return null;
			}

			if (!this.validatedate(control.value)) {
				return { invalid: true };
			}
			const dateValue = new Date(control.value);

			if (this.todate && dateValue < this.todate && type === "min") {
				return { invalid: true };
			}

			if (this.todate && dateValue < this.todate && type === "min") {
				return { invalid: true };
			}
			if (this.todate && dateValue > this.todate && type === "max") {
				return { invalid: true };
			}
			return null;
		};
	}

	public validatedate(inputText: string) {
		const dateformat = new RegExp(
			/(0[1-9]|1[012])[/.](0[1-9]|[12][0-9]|3[01])[/.]\d{4}$/
		);

		// Match the date format through regular expression
		if (dateformat.test(inputText)) {
			//Test which seperator is used '/' or '-'
			const opera1 = inputText.split("/");
			const opera2 = inputText.split("-");
			const lopera1 = opera1.length;
			const lopera2 = opera2.length;
			let pdate: string[] = new Array();
			// Extract the string into month, date and year
			if (lopera1 > 1) {
				pdate = inputText.split("/");
			} else if (lopera2 > 1) {
				pdate = inputText.split("-");
			}
			const mm = parseInt(pdate[0]);
			const dd = parseInt(pdate[1]);
			const yy = parseInt(pdate[2]);
			// Create list of days of a month [assume there is no leap year by default]
			const ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
			if (mm === 1 || mm > 2) {
				if (dd > ListofDays[mm - 1]) {
					return false;
				}
			}
			if (mm === 2) {
				let lyear = false;
				if ((!(yy % 4) && yy % 100) || !(yy % 400)) {
					lyear = true;
				}
				if (lyear === false && dd >= 29) {
					return false;
				}
				if (lyear === true && dd > 29) {
					return false;
				}
			}
		} else {
			return false;
		}
		return true;
	}

	public updateHeaderImageType(imageType: HeaderImageType) {
		this.headerImageType.next(imageType);
	}

	public getHeaderImageType$() {
		return this.headerImageType.asObservable();
	}

	private populateBrowserDetails() {
		AppUtil.log("populateBrowserDetails");

		this.browserDetails = new Object({});

		this.browserDetails.name = this.deviceService.getDeviceInfo().browser;
		this.browserDetails.version = this.deviceService.getDeviceInfo().browser_version;
		this.browserDetails.os = this.deviceService.getDeviceInfo().os;
		this.browserDetails.os_version = this.deviceService.getDeviceInfo().os_version;
		this.browserDetails.isMobile = this.deviceService.isMobile();
		this.browserDetails.isTablet = this.deviceService.isTablet();
		this.browserDetails.isDesktop = this.deviceService.isDesktop();
	}

	public logBrowserDetails() {
		AppUtil.log("Browser Details " + JSON.stringify(this.browserDetails));
	}
}
